import { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { baseUrl } from "../../api/api";

import logoFB from '../../assets/images/logo_facebook.svg';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';

const dev_app_id = '1469790316665360';
const prod_app_id = '1428601030784289';

const FacebookLoginButton = (props) => {
  const history = useHistory();
  const { handleSubmit } = props;

  const initClient = () => {
    return new Promise(resolve => {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: baseUrl.facebookAppId,
          cookie: true,
          xfbml: true,
          status: true,
          version: 'v22.0'
        });

        window.FB.AppEvents.logPageView();
      };

      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    })
  }

  useEffect(() => {
    initClient();
  }, [])

  const handleLogin = () => {
    window.FB.getLoginStatus((response) => {

      if (response.status === 'connected') {
        handleCredentialResponse(response.authResponse);
      } else {

        window.FB.login((response) => {
          if (response.status === 'connected') {
            // console.log('FB_token', response.authResponse);

            //test
            // window.FB.api('/me/permissions', (res) => {
            //   if (res && !res.error) {
            //     console.log('me_connected', res);
            //   } else {
            //     console.log('me_error', res);
            //   }
            // });

            //test
            // window.FB.api('/me', { fields: 'email' }, (res) => {
            //   console.log('me_email', res);
            // });

            const scopes = response.authResponse.grantedScopes?.split(',') ?? [];

            console.log('scopes', scopes);

            handleCredentialResponse(response.authResponse);

          } else if (response.status === 'not_authorized') {
            console.log('not authenticated app', response);
          } else {
            console.log('not logged', response);
          }
        },
          {
            scope: 'public_profile,email,business_management,ads_read,ads_management',
            auth_type: 'rerequest',
            return_scopes: true
          });
      }
    }, true);

  }

  const handleCredentialResponse = (res) => {
    // const checkToken = {
    //   accessToken: res.accessToken,
    //   userId: res.userID
    // }

    // console.log('Submit_token', checkToken);

    handleSubmit({
      media: basicConstants.FACEBOOK,
      query: {
        accessToken: res.accessToken,
        userId: res.userID
      }
    });
  }

  return (
    <>
      <Button
        variant="auth-outlined"
        onClick={handleLogin}
        sx={{ minWidth: '300px' }}
      >
        <img src={logoFB} alt="Facebook Login" style={{ width: '24px' }} />
        <Typography sx={{ mr: '24px' }}>
          <FormattedMessage id="account.modal.ContinueAccount" values={{ media: 'Facebook' }} />
        </Typography>
      </Button>
    </>
  )
}

export default FacebookLoginButton;